import React, { useEffect, useRef, useState } from 'react'
import { IoIosNotifications } from 'react-icons/io';
import { motion } from "framer-motion";
import axios from 'axios';
import { RiCalendar2Line } from 'react-icons/ri';
import { MdOutlineWatchLater } from 'react-icons/md';
import './Calendar.scss'

function CalendarNotification() {
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [notifications, setNotifications] = useState([]);
    const [newNotificationsCount, setNewNotificationsCount] = useState(0); // Track new notifications
    const dropdownRef = useRef(null);
    // console.log(setSearchQuery);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const API_URL = "https://ridehire-backend-2.onrender.com/host/reservation-event";

    useEffect(() => {
        fetchNotificationData();
    }, []);

    const fetchNotificationData = async () => {
        try {
            const response = await axios.get(API_URL);
            console.log("API Response:", response.data.events);

            // Keep only the latest 4 events
            setNotifications((response.data.events || []).slice(0, 4));
            setNewNotificationsCount(response.data.events.length > 4 ? 4 : response.data.events.length);
        } catch (error) {
            console.error("Error fetching notification data:", error);
        }
    };

    // Simulate adding a new notification when an event is added
    //     const addNewNotification = (newEvent) => {
    //       setNotifications((prevNotifications) => {
    //           // Add the new event to the front
    //           const updatedNotifications = [newEvent, ...prevNotifications];
    //           // Keep only the latest 4 notifications
    //           if (updatedNotifications.length > 4) {
    //               updatedNotifications.pop(); // Remove the oldest notification (first one)
    //           }
    //           return updatedNotifications;
    //       });
    //       setNewNotificationsCount((prevCount) => prevCount + 1); // Increase new notification count
    //   };

    // Format date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
        return `${formattedDate} (${dayOfWeek})`;
    };

    // Format time range
    const formatTimeRange = (startTime, endTime) => {
        const formatTime = (timeString) => {
            const date = new Date(timeString);
            return date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            }).toLowerCase();
        };
        return `${formatTime(startTime)} - ${formatTime(endTime)}`;
    };

    // Filter notifications based on search query
    const filteredNotifications = notifications.filter(notification => {
        const eventName = notification.event_name || '';
        return eventName.toLowerCase().includes(searchQuery.toLowerCase());
    });

    // Handle when the user opens the notification dropdown
    const handleOpenDropdown = () => {
        setIsOpen(!isOpen);
        if (newNotificationsCount > 0) {
            setNewNotificationsCount(0); // Reset notification count when the user opens the dropdown
        }
    };

    return (
        <div className="position-relative" ref={dropdownRef}>
            {/* Notification Icon */}
            <div className="notification-header position-relative" onClick={handleOpenDropdown}>
                <IoIosNotifications className="fs-3 cursor-pointer" />
                {newNotificationsCount > 0 && (
                    <span className="count position-absolute fs-6 d-flex align-items-center justify-content-center text-white">
                        {newNotificationsCount}
                    </span>
                )}
            </div>

            {/* Dropdown Menu with Slide Animation */}
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    className="position-absolute end-0 mt-2 w-64 bg-white notification-popup border shadow-lg rounded-lg p-3"
                >
                    <ul className='m-0 p-0 list-unstyled'>
                        {filteredNotifications.length > 0 ? (
                            filteredNotifications.map((notification, index) => (
                                <li key={index} className='mt-3'>
                                    <div className="notification-box p-2">
                                        <div className="d-flex">
                                            <div className="content">
                                                <div className="d-flex justify-content-between">
                                                    <div className="name-rupees d-flex ">
                                                        <p className='m-0 price-txt me-1'>{notification.total_price || '$0'}</p> &nbsp;
                                                    </div>
                                                    <div className="id text-dark">{notification.event_id || 'N/A'}</div>
                                                </div>

                                                <div className="d-flex">
                                                    <p className='passenger m-0 pt-2 text-dark'>{notification.passenger_Total_Size || 0} passenger&nbsp; {notification.bus_name || 'Unknown Bus'}</p>
                                                </div>

                                                <div className="d-xl-flex w-100 d-column align-items-baseline text-dark">
                                                    <div className="d-flex align-items-center">
                                                        <RiCalendar2Line className='calendar-icon me-1' />
                                                        <p className='m-0 date me-1'>{formatDate(notification.departureStartTime)}</p>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <MdOutlineWatchLater className='watch-icon h-100 me-1' />
                                                        <p className='m-0 time'>{formatTimeRange(notification.departureStartTime, notification.departureEndTime)}</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))
                        ) : (
                            <p>No events found</p>
                        )}
                    </ul>
                </motion.div>
            )}
        </div>
    );
}

export default CalendarNotification;
